(function() { window.GUID_8b48509a_aef9_4646_b7e2_48a5f5dfe95e = { getGuid: function() { return "8b48509a-aef9-4646-b7e2-48a5f5dfe95e"; } }; })();
var CS;
(function (CS) {
    class SignalRHelper {
        static get Instance() {
            if (!SignalRHelper.instance) {
                SignalRHelper.instance = new SignalRHelper();
            }
            return SignalRHelper.instance;
        }
        get ConnectionId() {
            var _a;
            return (_a = this.connection) === null || _a === void 0 ? void 0 : _a.connectionId;
        }
        constructor() {
            this.startCallbacks = [];
            this.Logging = false;
            let me = this;
            me.reconnectAttemptTimer = null;
            this.connection = new signalR.HubConnectionBuilder()
                .withUrl("/signalr")
                .configureLogging(this.Logging ? signalR.LogLevel.Information : signalR.LogLevel.None)
                .withAutomaticReconnect()
                .build();
            this.connection.onreconnecting(error => {
                if (this.Logging) {
                    console.log('SignalR reconnecting', error);
                }
                //clearInterval(this.reconnectAttemptTimer);
            });
            this.connection.onreconnected(connectionId => {
                if (this.Logging) {
                    console.log('SignalR reconnected', connectionId);
                }
                //clearInterval(this.reconnectAttemptTimer);
            });
            this.connection.onclose(error => {
                if (this.Logging) {
                    console.log('SignalR disconnected', error);
                }
                //    clearInterval(this.reconnectAttemptTimer);
                //    this.reconnectAttemptTimer = window.setInterval(() => {
                //        this.StartConnection();
                //    }, 5000); // Restart connection after 5 seconds.
            });
        }
        StartConnection(startCallback) {
            let me = this;
            if (me.Logging) {
                console.info('SignalR - StartConnection');
            }
            if (this.connection.state === signalR.HubConnectionState.Disconnected) {
                this.connection.start()
                    .then(() => {
                    this.notifyCallers(startCallback);
                })
                    .catch(err => {
                    console.error(err);
                });
            }
            else if (this.connection.state === signalR.HubConnectionState.Connected) {
                clearInterval(this.reconnectAttemptTimer);
                this.notifyCallers(startCallback);
            }
        }
        notifyCallers(startCallback) {
            //If startCallback is specified, only call this one
            if (startCallback) {
                startCallback.call(SignalRHelper.Instance);
            }
            else {
                if (this.Logging) {
                    console.info('SignalR - trigger all callbacks');
                }
                $('body').trigger("Start");
            }
        }
        Start(namespace, startCallback) {
            let me = this;
            $('body').off("Start." + namespace);
            $('body').on("Start." + namespace, startCallback);
            me.StartConnection(startCallback);
        }
        Stop(namespace, hubDisconectMethod, methodParameter) {
            let me = this;
            //clearInterval(me.reconnectAttemptTimer);
            if (this.Logging) {
                console.info('SignalR - Stopping - ' + namespace);
                if (hubDisconectMethod) {
                    console.info('          and invoking ' + hubDisconectMethod);
                }
            }
            if (namespace) {
                $('body').off("Start." + namespace);
            }
            if (hubDisconectMethod) {
                me.Invoke(hubDisconectMethod, null, methodParameter);
            }
            if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) {
                this.connection.stop();
            }
        }
        Invoke(methodName, callback, ...args) {
            if (this.connection.state === signalR.HubConnectionState.Disconnected) {
                this.StartConnection(() => {
                    this.connection.invoke(methodName, ...args)
                        .then(result => {
                        callback === null || callback === void 0 ? void 0 : callback.call(this, result);
                    })
                        .catch(err => {
                        if (this.Logging) {
                            console.error(err);
                        }
                    });
                });
            }
            else {
                this.connection.invoke(methodName, ...args)
                    .then(result => {
                    callback === null || callback === void 0 ? void 0 : callback.call(this, result);
                })
                    .catch(err => {
                    if (this.Logging) {
                        console.error(methodName + " " + err);
                    }
                });
            }
        }
        Receive(name, callback) {
            if (!this.connection) {
                return;
            }
            this.connection.off(name);
            this.connection.on(name, callback);
        }
    }
    CS.SignalRHelper = SignalRHelper;
})(CS || (CS = {}));

//# sourceMappingURL=cs-signalr.js.map
